import { defineStore } from 'pinia';
import { getActivityList } from '@/api/seller/activity';

export type ActivityItem = API.ActivityItem & { key: string };

interface ActivityListState {
  list: ActivityItem[]
}

export const useActivityList = defineStore({
  id: 'seller-activity-list',
  state: (): ActivityListState => ({
    list: [],
  }),
  getters: {},
  actions: {
    async getActivityList() {
      const res = await getActivityList();
      this.list = (res as any[] || []).map((item: API.ActivityItem) => ({
        ...item,
        key: item.id.toString(),
      }));
    },
  },
});
